import { ActionTree } from 'vuex';
import { RootState, IDevicesState } from '../types';
import { Client } from '@/common/apis/DeviceApi';
import ApiProvider from '@/common/apis/ApiProvider';

let loadDevicePromise: Promise<any> | null;

export const actions: ActionTree<IDevicesState, RootState> = {
    load({ dispatch, commit, rootState }, args: {reload: boolean}): Promise<any> {
        if (args && args.reload) {
            loadDevicePromise = null;
        }
        return loadDevicePromise || (loadDevicePromise = new Promise(async (resolve, reject) => {
            commit('setLoading', true);
            try {
                const api = ApiProvider.getDeviceApi();
                const devices = await api.getDevices({});
                if (devices.devices) {
                    commit('loaded', devices.devices);
                    resolve(devices);
                }
            } catch (e) {
                reject(e);
                commit('setLoading', false);
            }
        }));
    },
    async setDeviceName({ dispatch, commit, rootState }, args: {deviceNumber: string, name: string}): Promise<any> {
        const api = ApiProvider.getDeviceApi();
        await api.setDeviceName(args.name, args.deviceNumber);
        commit('nameUpdated', args);
    },

    // async login({ dispatch, commit }, args: SignInArguments): Promise<any> {
    //     commit('userLoggingIn');
    //     try {
    //         const client = new Client(ApiConfigurator.getAccountApiBaseUrl(), ApiConfigurator.getAxios());
    //         const loginResponse = await client.signIn(args);

    //         if (!loginResponse.user) {
    //             commit('userLoggedInFailed', 'Logged in failed');
    //         } else {
    //             commit('userLoggedIn', loginResponse.user);
    //         }
    //     } catch (e) {
    //         commit('userLoggedInFailed', e);
    //         throw e;
    //     }
    // },
};
